import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { OperationType, PixTransaction } from '../models/transaction.model';
import { PixExtractDetailsComponent } from './details/details.component';
import { ExtractService } from '../../extract/extract.service';
import * as moment from 'moment';
import { BankExtract } from '../../extract/extract.model';
import { FilterTypePeriod } from '../models/filter-type-period.enum';
import { Util } from '../../../utils/util';
import { ETipoOperacao } from '../models/qr-code-return.model';

@Component({
	selector: 'app-pix-extract',
	templateUrl: './extract.component.html',
	styleUrls: ['./extract.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixExtractComponent implements OnInit {

	public dataSource: MatTableDataSource<PixTransaction>;
	public displayedColumns: Array<string> = ['nome', 'tipo', 'data', 'valor', 'others'];
	public list: PixTransaction[] = [];
	public dateBegin = Util.DateAddDay(-14);
	public dateEnd = null;
	public detail = true;
	public filterTypePeriodSelected = FilterTypePeriod.BIWEEKLY;
	public operationType = OperationType;

	constructor(
		public dialog: MatDialog,
		private extractService: ExtractService,
	) {}

	ngOnInit(): void {
		this.getList();
	}

	onSelectedCustomPeriod(data: any) {
		if (data) {
			this.dateBegin = data.dateBegin ? data.dateBegin : Util.DateAddDay(-14);
			this.dateEnd = data.dateEnd ? data.dateEnd : null;
			this.getList();
		}
	}

	getList() {
		this.list = [];
		const dateBegin = moment(this.dateBegin).format('YYYY-MM-DD');
		const dateEnd = this.dateEnd ? moment(this.dateEnd).format('YYYY-MM-DD') : null;
		this.extractService.getExtractPix(dateBegin, dateEnd, this.detail).subscribe(result => {
			if (result.Sucesso && result.Existe) {
				const item = Util.keysToCamel(result.Retorno) as BankExtract;
				if (item.transacoes.length > 0) {
					this.list = this.convertModelToView(item);
				}
				this.dataSource = new MatTableDataSource(this.list);
			}
		});
	}

	convertModelToView(item: BankExtract): PixTransaction[] {
		return item.transacoes.map(o => new PixTransaction(o));
	}

	details(item: PixTransaction) {
		this.dialog.open(PixExtractDetailsComponent, {
			width: 'auto',
			data: item
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/extract/extract.component.ts